import { doodBlockConfig, propertyValue } from './dood-block-config';
import { cartPagePresetBlockBackgroundColorProperty } from './cart-page-preset-block-background.util';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTPREPAYMENTBLOCK_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "Couleurs" },
  "heading_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartPrepaymentBlockDescriptor: _generatedCartPrepaymentBlockDescriptor,
  cartPrepaymentBlockBlocDefinition,
  cartPrepaymentBlockDashboardLayout,
  cartPrepaymentBlockConfig,
  cartPrepaymentBlockResolveConfig,
  cartPrepaymentBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart - Prepayment Account",
    componentType: 'CartPrepaymentBlockComponent',
    category: 'cart',
    description: "Cart - Prepayment Account.",
    keywords: [],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    background_color: cartPagePresetBlockBackgroundColorProperty(),
    heading_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.cart-prepayment.heading-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-prepayment.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-page.fieldset.appearance.label",
            fields: ["background_color"],
          },
          {
            legend: "pages.blocks.cart-prepayment.fieldset.colors.label",
            fields: ["heading_color"],
          },
        ],
      },
    ],
  })
);

export function cartPrepaymentBlockDescriptor(): IBlockDescriptor;
export function cartPrepaymentBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartPrepaymentBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartPrepaymentBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartPrepaymentBlockDescriptor, cartPrepaymentBlockProperties, fieldOrder);
}

export {
  cartPrepaymentBlockBlocDefinition,
  cartPrepaymentBlockDashboardLayout,
  cartPrepaymentBlockProperties,
  cartPrepaymentBlockConfig,
  cartPrepaymentBlockResolveConfig,
};

export type CartPrepaymentBlockConfig = typeof cartPrepaymentBlockConfig;
